export const submitVariablesCreateTemplateSuccess = () => ({
	type: 'sendUIEvent',
	data: {
		source: 'variableInputDrawer',
		action: 'clicked',
		actionSubject: 'button',
		actionSubjectId: 'submitVariablesCreateTemplateSuccess',
	},
});
export const submitVariablesCreateTemplateError = (error) => ({
	type: 'sendUIEvent',
	data: {
		source: 'variableInputDrawer',
		action: 'clicked',
		actionSubject: 'button',
		actionSubjectId: 'submitVariablesCreateTemplateError',
		attributes: {
			error,
		},
	},
});
